<script>
export default {
  name: 'CommentIcon',
};
</script>

<template>
  <path
    d="M0.666748 2.49984C0.666748 1.48864 1.48888 0.666504 2.50008 0.666504H13.5001C14.5113 0.666504 15.3334 1.48864 15.3334 2.49984V10.7498C15.3334 11.761 14.5113 12.5832 13.5001 12.5832H9.5269L5.98342 15.2415C5.84591 15.3446 5.65972 15.3618 5.50216 15.2845C5.34461 15.2071 5.25008 15.0496 5.25008 14.8748V12.5832H2.50008C1.48888 12.5832 0.666748 11.761 0.666748 10.7498V2.49984ZM5.02092 4.7915C4.63993 4.7915 4.33341 5.09801 4.33341 5.479C4.33341 5.85999 4.63993 6.1665 5.02092 6.1665H10.9792C11.3602 6.1665 11.6667 5.85999 11.6667 5.479C11.6667 5.09801 11.3602 4.7915 10.9792 4.7915H5.02092ZM5.02092 7.5415C4.63993 7.5415 4.33341 7.84801 4.33341 8.229C4.33341 8.60999 4.63993 8.9165 5.02092 8.9165H8.22925C8.61024 8.9165 8.91675 8.60999 8.91675 8.229C8.91675 7.84801 8.61024 7.5415 8.22925 7.5415H5.02092Z"
  />
</template>
